/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Required_BadgeInputs */



/**
* | output |
* | --- |
* | "Required" |
*
* @param {Audio_Description_Export_Required_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_required_badge = /** @type {((inputs?: Audio_Description_Export_Required_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Required_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Requis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Necessario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Необходимый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Requerido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("必需的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("必須")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवश्यक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Obrigatório")
	return /** @type {LocalizedString} */ ("Required")
});